import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TicketApprover } from '../../services/ticketEasyService/model/ticketEasy/ticketApprover/TicketApprover';

interface TicketEasyModuleState {
    TicketEasyNoteDialogOpen: boolean;
    TicketEasyDocumentDialogOpen: boolean;
    TicketEasyInitiateDialogOpen: boolean;
    TicketEasySelectedStartModule: string;
    TicketConfigSelectedModule: string;
    TicketConfigSelectedTicketType: string;
    ApproverProfile: TicketApprover | null;
    FacilityApproverDialogOpen: boolean;
    DepartmentApproverDialogOpen: boolean;
    MessageViewType: 'all' | 'created' | 'approver' | 'allMessages' | 'myMessages' | 'pendingMyApproval';
}

const initialState: TicketEasyModuleState = {
    TicketEasyNoteDialogOpen: false,
    TicketEasyDocumentDialogOpen: false,
    TicketEasyInitiateDialogOpen: false,
    TicketEasySelectedStartModule: '',
    TicketConfigSelectedModule: '',
    TicketConfigSelectedTicketType: '',
    ApproverProfile: null,
    FacilityApproverDialogOpen: false,
    DepartmentApproverDialogOpen: false,
    MessageViewType: 'allMessages',
};

export const TicketEasyModuleSlice = createSlice({
    name: 'TicketEasyModuleSlice',
    initialState,
    reducers: {
        toggleTicketEasyNoteDialog: (state) => {
            state.TicketEasyNoteDialogOpen = !state.TicketEasyNoteDialogOpen;
        },
        toggleTicketEasyDocumentDialog: (state) => {
            state.TicketEasyDocumentDialogOpen = !state.TicketEasyDocumentDialogOpen;
        },
        toggleTicketEasyInitiateDialog: (state) => {
            state.TicketEasyInitiateDialogOpen = !state.TicketEasyInitiateDialogOpen;
        },
        setTicketEasySelectedStartModule: (state, action: PayloadAction<string>) => {
            state.TicketEasySelectedStartModule = action.payload;
        },
        setTicketConfigSelectedModule: (state, action: PayloadAction<string>) => {
            state.TicketConfigSelectedModule = action.payload;
        },        setTicketConfigSelectedTicketType: (state, action: PayloadAction<string>) => {
            state.TicketConfigSelectedTicketType = action.payload;
        },
        setApproverProfile: (state, action: PayloadAction<TicketApprover | null>) => {
            state.ApproverProfile = action.payload;
        },
        toggleFacilityApproverDialog: (state) => {
            state.FacilityApproverDialogOpen = !state.FacilityApproverDialogOpen;
        },        toggleDepartmentApproverDialog: (state) => {
            state.DepartmentApproverDialogOpen = !state.DepartmentApproverDialogOpen;
        },        setMessageViewType: (state, action: PayloadAction<'all' | 'created' | 'approver' | 'allMessages' | 'myMessages' | 'pendingMyApproval'>) => {
            state.MessageViewType = action.payload;
        },
    },
});

export const {
    toggleTicketEasyNoteDialog,
    toggleTicketEasyDocumentDialog,
    toggleTicketEasyInitiateDialog,
    setTicketEasySelectedStartModule,
    setTicketConfigSelectedModule,
    setTicketConfigSelectedTicketType,
    setApproverProfile,
    toggleFacilityApproverDialog,
    toggleDepartmentApproverDialog,
    setMessageViewType,
} = TicketEasyModuleSlice.actions;

export default TicketEasyModuleSlice.reducer;